import { useRoute } from 'vue-router/composables'
import { newTrack } from '@/track'
import { useHistoryStore } from '@/stores'

export function useElementClick() {
  const route = useRoute()

  const elementClick = function (name: string) {
    const historyStore = useHistoryStore()
    const prevPage: any = historyStore.$state.prevPage

    newTrack('biz_element_click', {
      element_name: name,
      title: route.meta?.title,
      host: window.location.origin,
      url: window.location.href,
      route_title: prevPage?.route_title,
      route_host: prevPage?.route_host,
      route_url: prevPage?.route_url,
    })
  }

  const elementClickForLogin = function (name: string, lastPage: any) {
    newTrack('biz_element_click', {
      element_name: name,
      title: route.meta?.title,
      host: window.location.origin,
      url: window.location.href,

      route_title: lastPage?.route_title,
      route_host: lastPage?.route_host,
      route_url: lastPage?.route_url,
    })
  }

  // 订阅或购买金币独有
  const elementClickForPay = function (name: string, options: any) {
    const historyStore = useHistoryStore()
    const prevPage: any = historyStore.$state.prevPage

    newTrack('biz_element_click', {
      element_name: name,
      title: route.meta?.title,
      host: window.location.origin,
      url: window.location.href,
      route_title: prevPage?.route_title,
      route_host: prevPage?.route_host,
      route_url: prevPage?.route_url,

      purchase_id: options.purchaseId, // 充值列表配置id
      commodity_id: options.commodityId, // 商品id
      purchase_type: options.purchaseType, // 购买类型 1-金币充值，2-VIP充值
      vip_type: options.vipType, // Vip类型 1-畅读会员，2-折扣会员(发金币的)
      price: options.price, // 商品价格
      vip_cycle: options.vipCycle, // 周期
      price_discount: options.priceDiscount, // 优惠价格
      vip_cycle_discount: options.vipCycleDiscount, // Vip周期优惠
      payment_channel: options.paymentChannel, // 支付方式
      purchase_scenario: options.purchaseScenario, // 场景类型
    })
  }

  return {
    elementClick,
    elementClickForLogin,
    elementClickForPay,
  }
}
